import { defineStore } from "pinia";

 
export const usePaginationStore = defineStore("pagination", () => {

   const lastPage = ref(1);

   const lastPageAddress = ref(1);


   const setLastPage = (page) => {
     lastPage.value = page
   }
 
   const setLastPageAddress  = (page) => {
    lastPageAddress .value = page
  }

      return {
        lastPage,
        setLastPage,
        lastPageAddress,
        setLastPageAddress
        
    }
})
